exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span {\n  clear: left;\n  display: inline;\n  text-align: left;\n}\n\n", ""]);

// exports
